module.exports = __webpack_public_path__ + "images/img-n3C2JLS.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/2.png
// module id = 2351
// module chunks = 0